import React from "react";
import { Pie } from "react-chartjs-2";
import Typography from "@material-ui/core/Typography";
import * as Dati from "../../../../Dati";
import * as Glob from "../../../../Globale";
import { Trad } from "../../../../components/";

interface IPieChartProps {
    Data: Dati.Dictionary<number>;
    Title?: string;
    TranslationsOff?: boolean;
}

export const _PieChart: React.FC<IPieChartProps> = ({ Data, Title, TranslationsOff }) => {
    const labels: string[] = [];
    const bgColors: string[] = [];
    const values: number[] = [];

    Object.keys(Data).forEach((key, index) => {
        labels.push(TranslationsOff ? key : Trad.Trad(key));
        values.push(Data[key]);
        bgColors.push(Glob.ColoreStaticA(index, 0.6));
    });

    return (
        <>
            {Title && <Typography variant="subtitle2">{Trad.Trad(Title)}</Typography>}
            <Pie
                data={{
                    labels,
                    datasets: [
                        {
                            data: values,
                            backgroundColor: bgColors
                        }
                    ]
                }}
            />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/common/Charts/PieChart.tsx